/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHelloworldData } from './helloworld.data';
import { IHelloworldProps } from './helloworld.props.autogenerated';

/**
 *
 * Helloworld component
 * @extends {React.PureComponent<IHelloworldProps<IHelloworldData>>}
 */
class Helloworld extends React.PureComponent<IHelloworldProps<IHelloworldData>> {
    public render(): JSX.Element {
        const { config } = this.props;

        return (
            <div className='row'>
                <div className='col'>
                    <h2>Config Value: {config.title}</h2>
                </div>
            </div>
        );
    }
}

export default Helloworld;
